import { createFetchSelectors } from './createFetchSelector';

export const fetchApiSelectors = createFetchSelectors('masses');

const fetchSelectors = {
  ...fetchApiSelectors,
};

export default fetchSelectors;
